.section {
    padding: 8px 0;
}

.header {
    width: 100%;
}

.label {
    font-family: monospace;
    font-weight: 600;
    font-size: 14px;
    color: rgb(50, 49, 48);
}

.content {
    padding-top: 8px;
}
